import { Incident } from '@collector/sportsapi-types'

import { Tables } from '../tables'
import { getTable } from '../utils'

export type AssignPlayerOnPitchRecord = {
  eventId: number
  incidentId: Incident['id']
}

export async function setIncident(
  eventId: number,
  incidentId: Incident['id'],
): Promise<void> {
  const table = getTable(Tables.ASSIGN_PLAYER_ON_PITCH)

  await table.put(
    {
      eventId,
      incidentId,
    },
    eventId,
  )
}

export async function remove(eventId: number): Promise<void> {
  const table = getTable(Tables.ASSIGN_PLAYER_ON_PITCH)

  return table.delete(eventId)
}

export function get(
  eventId: number,
): Promise<AssignPlayerOnPitchRecord | undefined> {
  const table = getTable(Tables.ASSIGN_PLAYER_ON_PITCH)

  return table.get(eventId)
}
